import { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { getPopup } from 'store/selectors';
import Loader from 'components/loader';

import popups from './config';

const Popups = () => {
  const popupsState = useSelector(getPopup);

  const openPopups = Object.entries(popupsState).filter(([, isOpen]) => isOpen);

  return (
    <>
      {openPopups.map(([name, isOpenedPopups]) => {
        const Popup = popups[name];
        return (
          <Suspense key={name} fallback={<Loader />}>
            <Popup isOpen={isOpenedPopups} />
          </Suspense>
        );
      })}
    </>
  );
};

export default Popups;
